module.exports = __webpack_public_path__ + "static/media/logo.6adb0983.svg";